import { CoreApplicationContext } from '@eventbrite/context-gen';
import React from 'react';
import { BrowserRouter, Route, StaticRouter, Switch } from 'react-router-dom';
import { HeroSectionProps } from './containers/HeroSection';
import { ThingsToDoBasePage } from './pages';
import { PointOfInterestPage } from './pages/point-of-interest';
import { ThingsToDoPage } from './pages/things-to-do';
import { PointOfInterestAppProps, ThingsToDoAppProps } from './types';

export const Routes: React.FC<
    (ThingsToDoAppProps | PointOfInterestAppProps) & CoreApplicationContext
> = (props) => {
    const Router = (
        process.env.REACT_APP_TARGET === 'server' ? StaticRouter : BrowserRouter
    ) as React.ElementType;

    const render = () => {
        props = props as React.PropsWithChildren<
            PointOfInterestAppProps & CoreApplicationContext
        >;
        return (
            <ThingsToDoBasePage footerLinks={props.footerLinks}>
                <PointOfInterestPage
                    nearbyEvents={props.nearbyEvents}
                    breadcrumbs={props.breadcrumbs}
                    pointOfInterest={props.pointOfInterest}
                    heroSection={props.heroSection}
                    nearbyPointsOfInterest={props.nearbyPointsOfInterest}
                />
            </ThingsToDoBasePage>
        );
    };
    return (
        <Router
            location={props.request.path}
            context={{}}
            forceRefresh={props.isBotRequest}
        >
            <Switch>
                <Route
                    path="/ttd/:locationSlug/"
                    exact={true}
                    render={() => {
                        props = props as React.PropsWithChildren<
                            ThingsToDoAppProps & CoreApplicationContext
                        >;
                        return (
                            <ThingsToDoBasePage footerLinks={props.footerLinks}>
                                <ThingsToDoPage
                                    breadcrumbs={props.breadcrumbs}
                                    trendingSearchesResult={
                                        props.trendingSearchesResult
                                    }
                                    nearbyCitiesResult={
                                        props.nearbyCitiesResult
                                    }
                                    categories={props.categories}
                                    topEventsData={props.topEventsData}
                                    heroSection={
                                        props.heroSection as HeroSectionProps
                                    }
                                    topOrganizers={props.topOrganizers}
                                    editorialCollections={
                                        props.editorial_collections
                                    }
                                />
                            </ThingsToDoBasePage>
                        );
                    }}
                />
                <Route
                    path="/poi/:location_slug/:point_of_interest_id"
                    exact={true}
                    render={render}
                />
                {/*
                    Core won't perform redirects in local dev, so a dev route is required.
                    In production, this route, /poi/:google_place_id, is redirected to
                    /poi/:location_slug/:point_of_interest_id before it hits the front-end.
                    */}
                {props.request.lifecycle === 'dev' && (
                    <Route
                        path="/poi/:google_place_id"
                        exact={true}
                        render={render}
                    />
                )}
            </Switch>
        </Router>
    );
};
